<template>
  <table class="ui striped basic table printable">
    <div v-show="loading" class="ui active inverted dimmer">
      <div class="ui text loader">Carregando...</div>
    </div>
    <thead>
      <tr>
        <th colspan="7" class="action-row">
          <div class="ui grid">
            <div class="row">
              <div class="four wide column">
                <router-link
                  class="new-record"
                  :to="`/contracts/${$route.params.contract_id}/associates/new`"
                >
                  <i class="plus icon"></i>Novo cadastro
                </router-link>
              </div>
              <div class="right aligned twelve wide column">
                <div class="actions">
                  <a @click.prevent="refresh()">
                    <i class="refresh icon"></i>Atualizar
                  </a>
                  <a @click.prevent="print()">
                    <i class="print icon"></i>Imprimir
                  </a>
                  <a @click.prevent="toCSV()">
                    <i class="file excel icon"></i>CSV
                  </a>
                </div>
              </div>
            </div>
          </div>
        </th>
      </tr>
      <tr>
        <!-- class="center aligned" -->
        <th></th>
        <th>Cod</th>
        <th>Titular</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(associate, index) in items" :key="index">
        <td class="actions">
          <router-link
            :to="`/contracts/${associate.contract_id}/associates/${associate.id}`"
          >
            <i class="edit icon"></i> Editar
          </router-link>
        </td>
        <td>{{ associate.id }}</td>
        <td>{{ associate.owner_name }}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr v-show="pageCount > 1">
        <th colspan="7" class="right aligned">
          <Paginate
            :page-count="pageCount"
            :click-handler="changePage"
            :total="paginate.total_entries"
            :entries="entriesOnPage"
            :value="paginate.current_page"
          ></Paginate>
        </th>
      </tr>
    </tfoot>
  </table>
</template>
<script>
import exportCSV from '@/utils/exportCSV';
import printTable from '@/utils/printTable';
import Paginate from '@/components/grid/widgets/paginate';

export default {
  components: { Paginate },
  data() {
    return {
      loading: false,
      items: [],
      paginate: {
        current_page: 0,
        per_page: 0,
        total_entries: 0
      }
    };
  },

  computed: {
    pageCount() {
      return Math.ceil(this.paginate.total_entries / this.paginate.per_page);
    },

    entriesOnPage() {
      const page_count = Math.ceil(
        this.paginate.total_entries / this.paginate.per_page
      );

      if (this.paginate.current_page === 1) {
        return page_count === 1
          ? this.paginate.total_entries
          : this.paginate.per_page;
      }

      return (
        this.paginate.total_entries %
        ((page_count - 1) * this.paginate.per_page)
      );
    }
  },

  methods: {
    getHeadersAndData() {
      const headers = ['Cod', 'Titular']
      const fields = this.items.map(item => ({cod: item.id, name: item.owner_name}))

      return { headers, data: fields };
    },
    changePage(pageNumber) {
      // scroll to top
      this._addQueryParam({ page: pageNumber });
      this.$scrollTop();

      this.$emit('page', pageNumber);
    },

    _addQueryParam(params) {
      const queryParams = Object.assign({}, this.$route.query, params);
      this.$router.replace({
        path: this.$route.path,
        query: queryParams
      });
    },

    refresh() {
      this.$emit('refresh');
    },

    toggleLoading() {
      this.loading = !this.loading;
    },

    print() {
      const { headers, data } = this.getHeadersAndData();
      printTable(headers, data);
    },

    toCSV() {
      const { headers, data } = this.getHeadersAndData();
      exportCSV(headers, data, `Associados`);
    },

    setData(items, paginate) {
      this.items = _.clone(items);
      this.paginate = _.clone(paginate);
    }
  }
};
</script>
<style lang="css" scoped>
.actions {
  font-weight: 400;
}

.actions a {
  padding: 0px 10px;
}
</style>
